import React from 'react';
import FuseScrollbars from '@fuse/core/FuseScrollbars';
import AppBar from '@material-ui/core/AppBar';
import Hidden from '@material-ui/core/Hidden';
import { makeStyles, /*useTheme*/ } from '@material-ui/core/styles';
//import Logo from 'app/fuse-layouts/shared-components/Logo';
//import NavbarFoldedToggleButton from 'app/fuse-layouts/shared-components/NavbarFoldedToggleButton';
import NavbarMobileToggleButton from 'app/fuse-layouts/shared-components/NavbarMobileToggleButton';
import Navigation from 'app/fuse-layouts/shared-components/Navigation';
//import UserNavbarHeader from 'app/fuse-layouts/shared-components/UserNavbarHeader';
import clsx from 'clsx';
//import Icon from '@material-ui/core/Icon';
import { useSelector } from 'react-redux';
import {CgArrowLongRightC} from 'react-icons/cg';
//import IconButton from '@material-ui/core/IconButton';

const useStyles = makeStyles({
	content: {
		overflowX: 'hidden',
		overflowY: 'auto',
		'-webkit-overflow-scrolling': 'touch',
		background:
			'linear-gradient(rgba(0, 0, 0, 0) 30%, rgba(0, 0, 0, 0) 30%), linear-gradient(rgba(0, 0, 0, 0.25) 0, rgba(0, 0, 0, 0) 40%)',
		backgroundRepeat: 'no-repeat',
		backgroundSize: '100% 40px, 100% 10px',
		backgroundAttachment: 'local, scroll',
	},
	animationIconLeft:{
		transform: 'rotateY(180deg)',
		transitionDuration: '0.8s',
	},
	animationIconRight:{
		transitionDuration: '0.8s',
	}
});

function NavbarLayout1(props) {
	const classes = useStyles();
	//const theme = useTheme();
	const leftMenuState = useSelector(({ fuse }) => fuse.navbar.foldedOpen);

	return (
		<div className={clsx('flex flex-col overflow-hidden h-full', props.className)}>
			<AppBar
				color="primary"
				position="static"
				elevation={0}
				className="flex flex-row items-center flex-shrink h-50 min-h-50 px-12"
			>
				{/*<div className="flex flex-1 mx-8">
					<Logo />
				</div>*/}

				{/* <Hidden mdDown>	
					<NavbarFoldedToggleButton className="w-40 h-40 p-0" />
				</Hidden> */}

				<Hidden mdDown>
					<NavbarMobileToggleButton className="w-40 h-50 p-0">
						{leftMenuState ? <CgArrowLongRightC className={classes.animationIconLeft}  /> : <CgArrowLongRightC className={classes.animationIconRight} />}
					</NavbarMobileToggleButton>
				</Hidden>

				<Hidden lgUp>
					<NavbarMobileToggleButton className="w-40 h-50 p-0">
						<CgArrowLongRightC className={classes.animationIconLeft}  />
					</NavbarMobileToggleButton>
				</Hidden>

			</AppBar>

			<FuseScrollbars className={clsx(classes.content)} option={{ suppressScrollX: true }}>
				{/*<UserNavbarHeader />*/}

				<Navigation layout="vertical" />
			</FuseScrollbars>
		</div>
	);
}

export default React.memo(NavbarLayout1);
